"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ApprovalClient_1 = require("client/ApprovalClient");
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const TextAreaWithMention_1 = __importDefault(require("components/shared/TextAreaWithMention/TextAreaWithMention"));
const ModalApprove = ({ isReject = false, setShowApprove, countState, teamId, objectiveId, approvalId, eventOnApproveOrReject, teamName, teamPicture }) => {
    const [showReasonModal, setShowReasonModal] = (0, react_1.useState)(false);
    const { user } = (0, UserContext_1.useUser)();
    const [metaMentions, setMetaMentions] = (0, react_1.useState)([]);
    const [comment, setComment] = (0, react_1.useState)('');
    const handleClickApprove = (isReject = false) => __awaiter(void 0, void 0, void 0, function* () {
        let params = {
            teamId: teamId,
            objectiveId: objectiveId
        };
        if (isReject) {
            const metaMentionsPayload = metaMentions.map((value) => {
                return {
                    userId: value === null || value === void 0 ? void 0 : value.userId,
                    startIndex: value === null || value === void 0 ? void 0 : value.startIndex,
                    length: value === null || value === void 0 ? void 0 : value.length
                };
            });
            params = Object.assign(Object.assign({}, params), { comment: comment, metaMentions: metaMentionsPayload });
        }
        const { isSuccess } = isReject
            ? yield (0, ApprovalClient_1.rejectApprovalById)(approvalId, params)
            : yield (0, ApprovalClient_1.approveApprovalById)(approvalId, params);
        if (isSuccess) {
            setShowApprove(false);
            eventOnApproveOrReject();
        }
    });
    return showReasonModal ? (react_1.default.createElement(Modal_1.default, { onClose: () => setShowReasonModal(false) },
        react_1.default.createElement(Modal_1.default.Header, { title: "Reason" }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "body-approval w-full px-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Reason (Required)')),
                react_1.default.createElement(TextAreaWithMention_1.default, { currentUserId: user === null || user === void 0 ? void 0 : user.id, setComment: setComment, metaMentions: metaMentions, setMetaMentions: setMetaMentions, source: "modal", customClass: "min-h-[88px]" }))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Reject All'),
                onClick: () => handleClickApprove(true),
                dataCy: 'approval-reason-modal-action'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: () => setShowReasonModal(false),
                dataCy: 'approval-reason-modal-cancel'
            }, useBorder: false }))) : (react_1.default.createElement(Modal_1.default, { onClose: () => setShowApprove(false), minWidth: 400, customClass: "w-[400px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: isReject ? 'Reject' : 'Approve' }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "flex flex-col w-full px-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-800 mb-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)(`You will ${isReject ? 'reject' : 'approve'} these objectives:`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('New')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState === null || countState === void 0 ? void 0 : countState.draft} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('Edited')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState === null || countState === void 0 ? void 0 : countState.edited} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('to_be_deleted')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState === null || countState === void 0 ? void 0 : countState.toBeDeleted} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)),
                react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-200 px-[16px] py-[8px] rounded-[4px]" },
                    react_1.default.createElement("p", { className: "typography-paragraph" }, (0, HelperUtils_1.getObjectiveLocale)('Existing')),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, `${countState === null || countState === void 0 ? void 0 : countState.existing} ${(0, HelperUtils_1.getObjectiveLocale)('objective')}(s)`)))),
        react_1.default.createElement(Modal_1.default.Footer, { userInfo: {
                profilePicture: teamPicture,
                name: teamName,
                dataCy: 'team-info'
            }, primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)(`${isReject ? 'Reject' : 'Approve'} All`),
                onClick: () => isReject ? setShowReasonModal(true) : handleClickApprove(false),
                dataCy: 'confirm'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: () => setShowApprove(false),
                dataCy: 'cancel-delete'
            }, useBorder: false })));
};
exports.default = ModalApprove;
